import { Controller, Control } from "react-hook-form";
import { RadioGroup as MuiRadioGroup, FormControlLabel, Radio, FormHelperText, Typography, useMediaQuery, useTheme } from "@mui/material";

type Option = {
  label: string;
  value: any;
};

type Props = {
  control: Control;
  name: string;
  label: string;
  options: Option[];
  defaultValue?: any;
  disabled?: boolean
};

const RadioGroup = ({ control, name, label, options, defaultValue, disabled }: Props) => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue ?? ""}
      rules={{ required: true }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          <Typography fontWeight={600} variant="body1" my={1}>{label}</Typography>
          <MuiRadioGroup aria-label={label} value={value} onChange={onChange} sx={{marginBottom:"15px"}}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={
                  <Radio 
                    sx={isPhone ? {padding:0, marginRight: "10px", marginLeft: "9px", top: "-10px"} : {}}
                  />}
                label={option.label}
                disabled={disabled}
              />
            ))}
          </MuiRadioGroup>
          {error && <FormHelperText error className="mb-2">Please select an option</FormHelperText>}
          {disabled && <FormHelperText error className="mb-2">Please answer the previous question</FormHelperText>}
        </>
      )}
    />
  );
};

export default RadioGroup;